<template>
  <div>
    <s9-pro></s9-pro>
    <cut-video></cut-video>
    <!--    <DisplayFirstImage></DisplayFirstImage>-->
    <div v-show="!isMobile">
      <DisplayContent></DisplayContent>
    </div>
    <!-- 打孔 -->
    <Punching></Punching>
    <!--    <TopFront title="两种高度。"></TopFront>-->
    <!-- 两种高度高度 -->
    <CutHeight></CutHeight>
    <TopFront :title="threeWidth" topDistance="250px"></TopFront>
    <!-- 三种宽度 -->
    <ThreeWidth></ThreeWidth>
    <!-- 两种长度 -->
    <TopFront :title="twoLength" topDistance="250px"></TopFront>
    <TwoLength></TwoLength>
    <TopFront :title="twoKnife" topDistance="250px"></TopFront>
    <TwoKnife></TwoKnife>
    <!-- 烟囱  -->
    <Chimney></Chimney>
    <!-- 坦克 -->
    <MachineRobustness></MachineRobustness>
    <!-- 气温 -->
    <HeatDissipationSystem></HeatDissipationSystem>
    <!-- 漏气吸不住 -->
    <GalaxyMars></GalaxyMars>
    <!-- 吸附力电机展示 -->
    <AdsorptionForce></AdsorptionForce>
    <!-- 土星系列 -->
<!--    <AdsorptionForce2></AdsorptionForce2>-->
    <!-- 土星系列详情 -->
    <AdsorptionForce3></AdsorptionForce3>
    <GalaxyMarsTwo></GalaxyMarsTwo>
    <!--    <GalaxyMarsThree></GalaxyMarsThree>-->
    <!-- 清洁周期延长  -->
    <CleanCycle></CleanCycle>
    <!-- 齿轮磨刀系统 -->
    <SharpeningSystem></SharpeningSystem>
<!--    <div style="width: 150%;height: 200px;background-color: #161617"></div>-->
    <!-- 振动箱 -->
    <VibrationBox></VibrationBox>
    <!-- 软著 -->
    <EvolutionSystem></EvolutionSystem>
    <!-- 边走边裁 -->
    <CutWhileMoving></CutWhileMoving>
    <FirstLook></FirstLook>
    <!-- 故障 -->
    <Malfunction></Malfunction>
    <div style="width: 150%;height: 200px;background-color: #f5f5f7"></div>
    <!-- 保养 -->
    <Maintenance></Maintenance>
    <!-- 选配 -->
    <OptionalSelection></OptionalSelection>
    <!-- 刀盘悬浮 -->
    <KnifeDiskSuspersion></KnifeDiskSuspersion>
    <!-- 再覆膜 -->
    <ReCoatingPage></ReCoatingPage>
    <!-- 断刀检测 -->
    <KnifeDetectionPage></KnifeDetectionPage>
    <!-- 智能进料辅助系统 -->
    <IntelligentFedding></IntelligentFedding>
    <!-- 扫码枪 -->
    <BarcodeScannerGun></BarcodeScannerGun>
    <!-- Saas -->
    <!--    <Sass></Sass>-->
    <!-- 硬件厂商 -->
    <HardwareVendor></HardwareVendor>
    <!-- 电源及能耗 -->
    <PowerAndWorking></PowerAndWorking>
    <!-- 全系产品细细看 -->
    <AllProducts></AllProducts>
    <!-- 数据展示 -->
    <CuttingBedData></CuttingBedData>
  </div>
</template>
<script>

import TopFront from "../components/Series/TopFront.vue";
// import TipMessage from "../components/Series/TipMessage.vue";
// import DisplayFirstImage from "../components/Series/DisplayFirstImage.vue";
import Punching from "../components/Series/Punching.vue";
import AllProducts from "../components/Series/AllProducts.vue";
import ThreeWidth from "../components/Series/ThreeWidth.vue";
import CuttingBedData from "../components/Series/CuttingBedData.vue";
import EvolutionSystem from "../components/Series/EvolutionSystem.vue";
import TwoKnife from "../components/Series/TwoKnife.vue";
import CutHeight from "../components/Series/CutHeight.vue";
// import FirstLook from "../components/Series/FirstLook.vue";
import TwoLength from "../components/Series/TwoLength.vue";
import Chimney from "@/components/Series/Chimney.vue";
import MachineRobustness from "@/components/Series/MachineRobustness.vue";
import HeatDissipationSystem from "@/components/Series/HeatDissipationSystem.vue";
import DisplayContent from "@/components/Series/DisplayContent.vue";
import GalaxyMars from "@/components/Series/GalaxyMars.vue";

// import taishi_video from "../static/taishi_video.mp4"
import GalaxyMarsTwo from "@/components/Series/GalaxyMarsTwo.vue";
import VibrationBox from "@/components/Series/VibrationBox.vue";
import CutWhileMoving from "@/components/Series/CutWhileMoving.vue";
// import GalaxyMarsThree from "@/components/Series/GalaxyMarsThree.vue";
import AdsorptionForce from "@/components/Series/AdsorptionForce.vue";
import CleanCycle from "@/components/Series/CleaningCycle.vue";
import SharpeningSystem from "@/components/Series/SharpeningSystem.vue";
import FirstLook from "@/components/Series/FirstLook.vue";
import Malfunction from "@/components/Series/Malfunction.vue";
import Maintenance from "@/components/Series/Maintenance.vue";
import OptionalSelection from "@/components/Series/OptionalSelection.vue";
import ReCoatingPage from "@/components/Series/Recoating.vue";
import KnifeDiskSuspersion from "@/components/Series/KnifeDiskSuspension.vue";
import KnifeDetectionPage from "@/components/Series/KnifeDetectionPage.vue";
import IntelligentFedding from "@/components/Series/IntelligentFedding.vue";
import BarcodeScannerGun from "@/components/Series/BarcodeScannerGun.vue";
// import Saas from "@/components/Series/Saas.vue";
import HardwareVendor from "@/components/Series/HardwareVendor.vue";
import PowerAndWorking from "@/components/Series/PowerAndWorking.vue";
import S9Pro from "@/components/Series/S9Pro.vue";
import CutVideo from "@/components/Series/CutVideo.vue";
import AdsorptionForce2 from "@/components/Series/AdsorptionForce2.vue";
import AdsorptionForce3 from "@/components/Series/AdsorptionForce3.vue";


export default {
  components: {
    AdsorptionForce3,
    AdsorptionForce2,
    CutVideo,
    S9Pro,
    PowerAndWorking,
    HardwareVendor,
    // Sass: Saas,
    BarcodeScannerGun,
    IntelligentFedding,
    KnifeDetectionPage,
    KnifeDiskSuspersion,
    ReCoatingPage,
    OptionalSelection,
    Maintenance,
    Malfunction,
    FirstLook,
    SharpeningSystem,
    CleanCycle,
    AdsorptionForce,
    CutWhileMoving,
    VibrationBox,
    GalaxyMarsTwo,
    GalaxyMars,
    TopFront,
    // TipMessage,
    // DisplayFirstImage,
    Punching,
    AllProducts,
    CuttingBedData,
    EvolutionSystem,
    TwoKnife,
    // FirstLook,
    CutHeight,
    ThreeWidth,
    TwoLength,
    Chimney,
    MachineRobustness,
    HeatDissipationSystem,
    DisplayContent,
    // GalaxyMarsThree
  },
  data() {
    return {
      isMobile: false,
      threeWidth: this.$i18n.t('series.threeWidth'),
      twoLength: this.$i18n.t('series.twoLength'),
      twoKnife: this.$i18n.t('series.twoKnife'),
      // src: taishi_video,
    }
  },
  name: 'SeriesS',
  methods: {},
  beforeDestroy() {
  },
  mounted() {
    this.$nextTick(() => {
      this.isMobile = window.innerWidth < 768
    })
  }
}
</script>

<style scoped lang="less">
.begin-video {
  width: 100%;

  video {
    width: 100%;
  }
}
</style>
